import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material"
import { IEstabelecimento } from "../../../../../../types/api/financeiro/operadoras-cartao"
import { TOpenModalEstabelecimentoData } from "./SelecaoEstabelecimentos"
import { useCallback, useMemo, useState } from "react";
import SelectLoja from "../../../../../../components/SelectsSimpleApiQuery/SelectLoja";

export default function DialogCrudEstabelecimento({
  values,
  valueIndex,
  lastId,
  open,
  handleClose,
  onSubmit
}: DialogCrudEstabelecimentoProps) {

  const isEdit = useMemo(() => Boolean(values), [values])
  const valoresIniciais = useMemo(() => ({
    id: values?.id,
    numeroEstabelecimento: values?.numero_estabelecimento || '',
    loja: values?.loja ? { id: values.loja.id, nome: values.loja.nome } : null,
  }), [values])

  const [selectLoja, setSelectLoja] = useState<TSelectState>(valoresIniciais.loja)
  const [numeroEstabelecimento, setNumeroEstabelecimento] = useState<string>(valoresIniciais.numeroEstabelecimento)

  //Função manipuladora
  const handleSubmit = useCallback(() => {
    if (!selectLoja) return

    let params: IEstabelecimento = {
      id: valueIndex !== undefined ? valueIndex : lastId + 1,
      numero_estabelecimento: numeroEstabelecimento,
      loja: {
        id: selectLoja.id,
        nome: selectLoja.nome
      }
    }

    onSubmit(params)
    handleClose()
  }, [
    handleClose,
    onSubmit,
    selectLoja,
    numeroEstabelecimento,
    valueIndex,
    lastId
  ])
  //

  const podeContinuar = useMemo(() => {
    if (!selectLoja || numeroEstabelecimento === '') {
      return false
    }
    return true
  }, [selectLoja, numeroEstabelecimento])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        Vincular estabelecimento
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} p={1}>
          <Grid size={{xs: 12, md: 6}}>
            <TextField
              fullWidth
              type="number"
              label="Número estabelecimento"
              value={numeroEstabelecimento}
              onChange={(e) => setNumeroEstabelecimento(e.target.value)}
            />
          </Grid>

          <Grid size={{xs: 12, md: 6}}>
            <SelectLoja
              value={selectLoja}
              onChange={(e) => setSelectLoja(e)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          autoFocus
          variant="contained"
          onClick={handleSubmit}
          disabled={!podeContinuar}
        >
          {isEdit ? "Atualizar" : "Vincular"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

interface DialogCrudEstabelecimentoProps {
  values: TOpenModalEstabelecimentoData
  valueIndex: number | undefined
  lastId: number
  open: boolean
  handleClose: () => void
  onSubmit: (valor: IEstabelecimento) => void
}

type TSelectState = {
  id: number,
  nome: string
} | null